import { RadioGroupField, RadioGroupFieldProps } from 'components/form'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

const options = [
  { value: RastreioCancerPerguntaOpcaoEnum.NORMAL, label: 'Normal' },
  {
    value: RastreioCancerPerguntaOpcaoEnum.AUSENTE,
    label: 'Ausente (Anomalias congênitas ou retirado cirurgicamente)',
  },
  { value: RastreioCancerPerguntaOpcaoEnum.ALTERADO, label: 'Alterado' },
  { value: RastreioCancerPerguntaOpcaoEnum.COLO_UTERO_NAO_VISUALIZADO, label: 'Colo de útero não visualizado' },
]

export function InspecaoColoRadioField(
  props: Readonly<Omit<RadioGroupFieldProps<RastreioCancerPerguntaOpcaoEnum>, 'options'>>
) {
  return <RadioGroupField label='Inspeção do colo' lines={2} {...props} options={options} />
}
